// extracted by mini-css-extract-plugin
export default {"result":"SearchResult_result__iER6O","result_column":"SearchResult_result_column__9zg48"};